'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	ProgressContentStatusUpdater = require('./progress-content-status-updater'),
	_ = require('underscore');
module.exports = function ProgressModel(mapModel, statusCalculator, activityLog) {
	let activeContent,
		contentStatusUpdater,
		activeFilter,
		currentData,
		projectionNames,
		isActive = false,
		currentStatusConfig,
		activeProjectionName;

	const self = observable(this),
		oldAddEventListener = self.addEventListener,
		logProjection = function () {
			if (activityLog) {
				activityLog.log('CalcModel', 'Projection:' + activeProjectionName);
			}
		},
		projectionByName = function (name) {
			return _.find(statusCalculator.getProjectionsFor(activeContent), function (projection) {
				return projection.name === name;
			});
		},
		recalcAndPublish = function () {
			if (activeProjectionName && self.listeners('dataUpdated').length > 0) {
				currentData = statusCalculator.dataAdapter(activeContent, activeFilter);
				self.dispatchEvent('dataUpdated', projectionByName(activeProjectionName).iterator(currentData), activeFilter);
			}
		},
		getContext = function () {
			const isEnabled = !!currentStatusConfig;
			return {
				isActive: isActive,
				isEnabled: isEnabled,
				currentStatusConfig: currentStatusConfig
			};
		},
		dispatchContext = function () {
			self.dispatchEvent('progressContext', getContext());
		};

	self.setActive = function (active) {
		isActive = active;
		dispatchContext();
	};
	self.addEventListener = function (event, listener) {
		if (activeContent && event === 'dataUpdated' && self.listeners('dataUpdated').length === 0) {
			currentData = statusCalculator.dataAdapter(activeContent, activeFilter);
			logProjection();
		}
		oldAddEventListener(event, listener);
		if (activeContent && event === 'dataUpdated') {
			listener.apply(undefined, [projectionByName(activeProjectionName).iterator(currentData), activeFilter]);
		}
	};
	self.setFilter = function (newFilter) {
		if (_.isEqual(newFilter, activeFilter)) {
			return;
		}
		activeFilter = newFilter;
		recalcAndPublish();
	};
	self.getFilter = function () {
		return activeFilter;
	};
	self.getActiveProjection = function () {
		return activeProjectionName;
	};
	self.dataUpdated = function (content) {
		activeContent = content;
		const newProjectionNames =  _.map(statusCalculator.getProjectionsFor(activeContent), function (projection) {
			return projection.name;
		});
		if (!_.isEqual(newProjectionNames, projectionNames)) {
			projectionNames = newProjectionNames;
			self.dispatchEvent('projectionsChanged', projectionNames);
		}
		if (!_.include(projectionNames, activeProjectionName)) {
			activeProjectionName = _.first(projectionNames);
		}
		recalcAndPublish();
	};
	self.setActiveProjection = function (name) {
		if (activeProjectionName === name) {
			return;
		}

		if (projectionByName(name)) {
			activeProjectionName = name;
			logProjection();
			recalcAndPublish();
		}
	};
	self.getFilterPredicate = function () {
		const data = _.map(currentData || statusCalculator.dataAdapter(activeContent, activeFilter), function (item) {
			return item.id;
		});
		return function (idea) {
			return _.include(data, idea.id);
		};
	};
	self.getContentStatusUpdater = function () {
		return contentStatusUpdater;
	};
	self.bindContentListeners = function () {
		const activeContent = mapModel.getIdea(),
			publishData = function () {
				self.dataUpdated(activeContent);
			};
		contentStatusUpdater = new ProgressContentStatusUpdater(activeContent);
		currentStatusConfig = contentStatusUpdater.getStatusConfig();
		contentStatusUpdater.addEventListener('configChanged', function (statusConfig) {
			currentStatusConfig = statusConfig;
			self.setFilter({});
			dispatchContext();
			self.dispatchEvent('configChanged', statusConfig);
		});
		mapModel.addEventListener('nodeSelectionChanged', function () {
			const filter = self.getFilter() || {};
			if (filter.subtree) {
				publishData();
			}
		});
		activeContent.addEventListener('changed', publishData);
		publishData();
	};
	self.resetProgress = function () {
		if (contentStatusUpdater) {
			contentStatusUpdater.clear();
		}
	};
	self.setStatusConfig = function (statusConfig) {
		if (contentStatusUpdater) {
			contentStatusUpdater.setStatusConfig(statusConfig);
		}
	};
	self.updateActivatedStatus = function (newStatusName) {
		mapModel.applyToActivated(function (id) {
			contentStatusUpdater.updateStatus(id, newStatusName);
		});
	};
	self.toggleFilterProperty = function (filterProperty) {
		if (!activeFilter) {
			activeFilter = {
			};
		}
		if (!activeFilter[filterProperty]) {
			if (filterProperty === 'subtree') {
				activeFilter.subtree = mapModel.getCurrentlySelectedIdeaId;
			} else {
				activeFilter[filterProperty] = true;
			}

		} else {
			delete activeFilter[filterProperty];
		}
		recalcAndPublish();
	};
	self.setFilterStatus = function (statusKey, active) {
		if (!activeFilter) {
			if (!currentStatusConfig) {
				return;
			}
			activeFilter = {};
		}
		if (!activeFilter.statuses) {
			activeFilter.statuses = _.map(currentStatusConfig, function (status, key) {
				return key;
			});
		}
		const isIncluded = _.contains(activeFilter.statuses, statusKey);
		if (isIncluded && !active) {
			activeFilter.statuses = _.without(activeFilter.statuses, statusKey);
			recalcAndPublish();
		} else if (!isIncluded && active) {
			activeFilter.statuses.push(statusKey);
			recalcAndPublish();
		}
	};
	self.selectAllFilterStatuses = function () {
		if (!activeFilter || !activeFilter.statuses) {
			return;
		}

		delete activeFilter.statuses;
		recalcAndPublish();
	};
};
